import React from "react";
import cx from "classnames";
import styles from "./salesforceConfigurationView.module.scss";
import isEqual from "is-equal";
import { toast } from "react-toastify";
import LoadingMessage from "src/legacy/components/LoadingMessage";
import {
  Row,
  Button,
  Col,
  FormGroup,
  InputGroup,
  Form,
  FormControl,
  ButtonGroup,
  Alert,
  Collapse
} from "react-bootstrap";
import SendButton from "src/legacy/components/SendButton";
import PlaceholderEmptyMessage from "src/legacy/components/PlaceholderEmptyMessage";
import AccessDeniedIcon from "src/legacy/images/access_denied.svg";
import OpportunityFieldDropdown from "../fields/OpportunityFieldDropdown";
import CustomFieldDropdown from "../fields/CustomFieldDropdown";
import _ from "lodash";
import buildUrl from "build-url-ts";
import SlidePaneView from 'src/legacy/components/SlidePaneView';
import ButtonContainer from 'src/legacy/components/Button';
import { localizedStrings } from 'src/localization/index.jsx';
import Toast from "src/components/toast";
import SwitchButton from "src/components/switchButton";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

class SalesforceConfigurationView extends React.Component {
  constructor(props) {
    super(props);
    const primaryIntegration = this.props.integration;

    this.state = {
      primaryId: _.get(primaryIntegration, "id"),
      primaryCreatedBy: _.get(primaryIntegration, "createdBy"),
      primaryEmail: _.get(primaryIntegration, "configuration.email") || '',
      primaryInstance: _.get(primaryIntegration, "configuration.instance") || '',
      primarySyncReadAssetEvent: _.get(primaryIntegration, "configuration.syncReadAssetEvent") || false,
      primarySyncReadConversationEvent:
        _.get(primaryIntegration, "configuration.syncReadConversationEvent") || false,
      primarySyncReshareConversationEvent: _.get(primaryIntegration, "configuration.syncReshareConversationEvent") || false,
      primarySyncLeadCreatedEvent: _.get(primaryIntegration, "configuration.syncLeadCreatedEvent") || false,
      primarySyncDeals: _.get(primaryIntegration, "configuration.syncDeals") || false,
      primarySyncAssetDownloadEvent: _.get(primaryIntegration, "configuration.syncAssetDownloadEvent"),
      errors: {},
      showAddFieldButton: true,
      sharedFieldsSync: false,
      sharedFieldsEdit: false,
      opportunityFields: this.props.opportunityFields,
      removeCustomFields: [],
      customFields: this.props.customFields,
      newCustomFields: [],
      editMode: false,
      secondaryInstanceEvents: {
        syncAssetDownloadEvent: _.get(this.props, "primaryInstanceOverride.configuration.syncAssetDownloadEvent", true),
        syncDeals: _.get(this.props, "primaryInstanceOverride.configuration.syncDeals", true),
        syncLeadCreatedEvent: _.get(this.props, "primaryInstanceOverride.configuration.syncLeadCreatedEvent", true),
        syncReadAssetEvent: _.get(this.props, "primaryInstanceOverride.configuration.syncReadAssetEvent", true),
        syncReadConversationEvent: _.get(this.props, "primaryInstanceOverride.configuration.syncReadConversationEvent", true),
        syncReshareConversationEvent: _.get(this.props, "primaryInstanceOverride.configuration.syncReshareConversationEvent", true),
      }
    };

    this._toggleSwitchChange = this._toggleSwitchChange.bind(this);
    this._handleSaveChangesClicked = this._handleSaveChangesClicked.bind(this);
    this._handleResetClicked = this._handleResetClicked.bind(this);
    this._handleSyncSharedFields = this._handleSyncSharedFields.bind(this);

    this._renderCustomFields = this._renderCustomFieldsInTags.bind(this);
    this._renderCustomFieldsInEditMode = this._renderCustomFieldsInEditMode.bind(this);
    this._removeCustomField = this._removeCustomField.bind(this);

    this._renderNewCustomFields = this._renderNewCustomFields.bind(this);

    this._addNewCustomField = this._addNewCustomField.bind(this);
    this._removeNewCustomField = this._removeNewCustomField.bind(this);

    this._handleAddFieldButton = this._handleAddFieldButton.bind(this);
    this.prepareUserConfiguration = this.prepareUserConfiguration.bind(this);
    this.prepareAdminConfiguration = this.prepareAdminConfiguration.bind(this);
    this._handlePrimaryResetClicked = this._handlePrimaryResetClicked.bind(this);
    this.handleAuthenticateEvent = this.handleAuthenticateEvent.bind(this);
    this.handleSalesforceAuthenticate = this.handleSalesforceAuthenticate.bind(this);
    this._renderSecondaryInstance = this._renderSecondaryInstance.bind(this);
    this.handleRemoveClick = this.handleRemoveClick.bind(this);
    this.handleSecondaryInstanceEventsChange = this.handleSecondaryInstanceEventsChange.bind(this);
    this.handleSecondaryInstanceReset = this.handleSecondaryInstanceReset.bind(this);
    this.handleSecondaryInstanceSave = this.handleSecondaryInstanceSave.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedSalesforce = localizedStrings.components.integrations.salesforce;
    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedIntgerationActions = localizedStrings.components.integrations.actions;
  }

  prepareUserConfiguration(integration) {
    if (integration != null) {
      this.setState({
        id: _.get(integration, "id"),
        email: _.get(integration, "configuration.email") || '',
        instance: _.get(integration, "configuration.instance") || '',
        syncReadAssetEvent: _.get(integration, "configuration.syncReadAssetEvent") || false,
        syncReadConversationEvent: _.get(integration, "configuration.syncReadConversationEvent") || false,
        syncReshareConversationEvent: _.get(integration, "configuration.syncReshareConversationEvent") || false,
        syncLeadCreatedEvent: _.get(integration, "configuration.syncLeadCreatedEvent") || false,
        syncDeals: _.get(integration, "configuration.syncDeals") || false,
        syncAssetDownloadEvent: _.get(integration, "configuration.syncAssetDownloadEvent"),
        errors: {}
      })
    }
  }

  prepareAdminConfiguration(primaryIntegration) {
    this.setState({
      primaryId: _.get(primaryIntegration, "id"),
      primaryCreatedBy: _.get(primaryIntegration, "createdBy"),
      primaryEmail: _.get(primaryIntegration, "configuration.email") || '',
      primaryInstance: _.get(primaryIntegration, "configuration.instance") || '',
      primarySyncReadAssetEvent: _.get(primaryIntegration, "configuration.syncReadAssetEvent") || false,
      primarySyncReadConversationEvent: _.get(primaryIntegration, "configuration.syncReadConversationEvent") || false,
      primarySyncReshareConversationEvent: _.get(primaryIntegration, "configuration.syncReshareConversationEvent") || false,
      primarySyncLeadCreatedEvent: _.get(primaryIntegration, "configuration.syncLeadCreatedEvent") || false,
      primarySyncDeals: _.get(primaryIntegration, "configuration.syncDeals") || false,
      primarySyncAssetDownloadEvent: _.get(primaryIntegration, "configuration.syncAssetDownloadEvent"),
    })
  }

  componentDidMount() {
if (_.get(this.props, 'integration')) {
      if (_.get(this.props, 'integration.primaryIntegration')) {
        this.fetchCustomFields(_.get(this.props, 'integration.primaryIntegration.id'));
        this.prepareAdminConfiguration(_.get(this.props, 'integration.primaryIntegration'));
        if (_.get(this.props, 'integration.state.code') === "ok") {
          this.prepareUserConfiguration(_.get(this.props, 'integration'));
        }
      } else {
        this.fetchCustomFields(_.get(this.props, 'integration.id'));
        this.prepareAdminConfiguration(_.get(this.props, 'integration'));
        }
      }
    
    if (this.props.adminConfiguration) {
      if (_.get(this.props, "adminConfiguration.state.code") === "auth_error" && _.get(this.props, "primaryInstanceOverride.configuration.email")) {
        this.setState({ isPrimaryExpired: true });
      }
    }

  }
  

  fetchCustomFields(integrationId) {

    let filters = {
      types: ["LIST"]
    }

    this.props.fetchOpportunityFields(integrationId, filters);
    this.props.fetchCustomFields(integrationId);
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.integration, this.props.integration)) {
      if (nextProps.integration) {
        if (nextProps.integration.primaryIntegration) {
          this.fetchCustomFields(nextProps.integration.primaryIntegration.id)
          this.prepareAdminConfiguration(nextProps.integration.primaryIntegration);
          if (_.get(nextProps, "integration.state.code") === "ok") {
            this.prepareUserConfiguration(nextProps.integration)
          }
        } else {
          this.fetchCustomFields(nextProps.integration.id)
          this.prepareAdminConfiguration(nextProps.integration);
        }
      }
    }
    if (_.get(nextProps, "primaryInstanceOverride.configuration.instance") && !_.get(nextProps,"primaryInstanceOverride.configuration.email")) {
      this.setState({
        showSecondaryInstance: true,
        isSecondaryInstanceEdit: false,
        collapsePrimary: true
      })
    }
    if (!isEqual(_.get(nextProps, "primaryInstanceOverride.configuration"), _.get(this.props, "primaryInstanceOverride.configuration"))) {
      this.setState({
        secondaryInstanceEvents: {
          syncAssetDownloadEvent: _.get(nextProps, "primaryInstanceOverride.configuration.syncAssetDownloadEvent", true),
          syncDeals: _.get(nextProps, "primaryInstanceOverride.configuration.syncDeals", true),
          syncLeadCreatedEvent: _.get(nextProps, "primaryInstanceOverride.configuration.syncLeadCreatedEvent", true),
          syncReadAssetEvent: _.get(nextProps, "primaryInstanceOverride.configuration.syncReadAssetEvent", true),
          syncReadConversationEvent: _.get(nextProps, "primaryInstanceOverride.configuration.syncReadConversationEvent", true),
          syncReshareConversationEvent: _.get(nextProps, "primaryInstanceOverride.configuration.syncReshareConversationEvent", true),
        }
      })
    }
    if (nextProps.adminConfiguration) {
      if (_.get(nextProps, "adminConfiguration.state.code") === "auth_error" && _.get(nextProps, "primaryInstanceOverride.configuration.email")) {
        this.setState({
          isPrimaryExpired: true
        });
      } else if (_.get(nextProps, "adminConfiguration.state.code") === "ok") {
        this.setState({
          isPrimaryExpired: false
        });
      }
    }
    this.setState({
      customFields: nextProps.customFields,
      opportunityFields: nextProps.opportunityFields,
    });

    if(!this.state.showSecondaryInstance){
      this.setState({
        expand:true
      })
    }
  }

  _toggleSwitchChange(field) {
    this.setState({
      [field]: !this.state[field],
    });
  }

  handleSecondaryInstanceEventsChange(field) {
    
    this.setState(prevState => {
      return {
        secondaryInstanceEvents: {
          ...prevState.secondaryInstanceEvents,
          [field]: !prevState.secondaryInstanceEvents[field],
        }
      }
    });
  }

  _handleSaveChangesClicked(type) {
    let request = {
      integrationId: type === 'primary' ? this.state.primaryId : this.state.id,
      syncReadAssetEvent: type === 'primary' ? this.state.primarySyncReadAssetEvent : this.state.syncReadAssetEvent,
      syncReadConversationEvent: type === 'primary' ? this.state.primarySyncReadConversationEvent : this.state.syncReadConversationEvent,
      syncReshareConversationEvent: type === 'primary' ? this.state.primarySyncReshareConversationEvent : this.state.syncReshareConversationEvent,
      syncLeadCreatedEvent: type === 'primary' ? this.state.primarySyncLeadCreatedEvent : this.state.syncLeadCreatedEvent,
      syncDeals: type === 'primary' ? this.state.primarySyncDeals : this.state.syncDeals,
      syncAssetDownloadEvent: type === 'primary' ? this.state.primarySyncAssetDownloadEvent : this.state.syncAssetDownloadEvent,
    }

    this.props.updateConfiguration(request).then(() => {
      toast(
        <Toast.Sucess
          message={this.localizedIntegrations.toast.salesforce}
        />,
        {
          autoClose: 3000,
        }
      );
      this.setState({
        isSecondaryConfigEdit: false,
        editMode: false
      })
    });

    if (!_.isEmpty(this.state.newCustomFields)) {
      this.props
        .saveOpportunityFields(
          this.state.primaryId,
          this.state.newCustomFields
        )
        .then(() => {
          this.setState({
            newCustomFields: [],
            customFields: this.props.customFields,
          });
        });
    }

    if (!_.isEmpty(this.state.removeCustomFields)) {
      this.props
        .deleteCustomFields(
          this.state.primaryId,
          this.state.removeCustomFields
        )
        .then(() => {
          this.setState({ sharedFieldsEdit: false, removeCustomFields: [] });
        });
    }
  }

  _handlePrimaryResetClicked() {
    let integration = this.props.integration;
    if (this.props.integration.primaryIntegration) {
      integration = this.props.integration.primaryIntegration
    }

    this.setState({
      primarySyncReadAssetEvent: _.get(integration, "configuration.syncReadAssetEvent"),
      primarySyncReadConversationEvent: _.get(integration, "configuration.syncReadConversationEvent"),
      primarySyncReshareConversationEvent: _.get(integration, "configuration.syncReshareConversationEvent"),
      primarySyncLeadCreatedEvent: _.get(integration, "configuration.syncLeadCreatedEvent"),
      primarySyncDeals: _.get(integration, "configuration.syncDeals"),
      primarySyncAssetDownloadEvent: _.get(integration, "configuration.syncAssetDownloadEvent"),
      sharedFieldsEdit: false,
      showAddFieldButton: true,
      customFields: this.props.customFields,
      removeCustomFields: [],
      newCustomFields: [],
    });
  }

  _handleResetClicked() {
    this.setState({
      syncReadAssetEvent:
        _.get(this.props.integration, "configuration.syncReadAssetEvent"),
      syncReadConversationEvent:
        _.get(this.props.integration, "configuration.syncReadConversationEvent"),
      syncReshareConversationEvent:
        _.get(this.props.integration, "configuration.syncReshareConversationEvent"),
      syncLeadCreatedEvent:
        _.get(this.props.integration, "configuration.syncLeadCreatedEvent"),
      syncAssetDownloadEvent:
        _.get(this.props.integration, "configuration.syncAssetDownloadEvent"),
      syncDeals: _.get(this.props.integration, "configuration.syncDeals")
    });
  }

  _handleSyncSharedFields() {
    if (this.props.integration) {
      this.setState({
        sharedFieldsSync: true,
        showAddFieldButton: true,
        removeCustomFields: [],
        newCustomFields: [],
      });

      this.props.syncOpportunityFields(this.state.primaryId).then(() => {
        toast(
          <Toast.Sucess
            message={this.localizedSalesforce.update_fields_success}
          />,
          {
            autoClose: 3000,
          }
        );

        this.setState({
          sharedFieldsSync: false,
          sharedFieldsEdit: false,
          removeCustomFields: [],
          newCustomFields: [],
          customFields: this.props.customFields,
        });
      });

      this.props.fetchOpportunityFields(this.state.primaryId).then(() => {
        this.setState({ opportunityFields: this.props.opportunityFields });
      });
    }
  }


  _renderCustomFieldsInTags() {
    var items = this.state.customFields || [];

    return (
      <div className={styles.customFields}>
        {items.map((field, index) => {
          return (
            <div key={index} className={styles.text}>
              {field.name}
            </div>
          );
        })}
      </div>
    );
  }

  _renderCustomFieldsInEditMode() {
    var removeCustomFields = this.state.removeCustomFields;
    if (this.state.customFields) {
      var fields = this.state.customFields
        .filter((field, index) => removeCustomFields.indexOf(field.id) === -1)
        .map((field, index) => {
          return (
            <div className={styles.opportunityField} key={index}>
              <CustomFieldDropdown
                key={field.name}
                selected={{ ...field }}
                removeCustomField={this._removeCustomField}
              />
            </div>
          );
        });

      return fields;
    }
  }

  _removeCustomField(field) {
    var removeCustomFields = this.state.removeCustomFields;
    removeCustomFields.push(field.id);

    this.setState({
      removeCustomFields: removeCustomFields,
    });
  }

  _handleAddFieldButton(item) {
    this.setState({
      ...this.state,
      showAddFieldButton: !this.state.showAddFieldButton,
    });
  }

  _renderNewCustomFields() {
    var items = this.state.newCustomFields || [];

    var fields = items.map((field, index) => {
      return (
        <div className={styles.opportunityField} key={index}>
          <OpportunityFieldDropdown
            key={field.name}
            fields={[...this.state.opportunityFields]}
            selected={{ ...field }}
            onRemove={this._removeNewCustomField}
          />
        </div>
      );
    });

    return fields;
  }

  _addNewCustomField(field) {
    if (!field) {
      return;
    }

    var newCustomFields = this.state.newCustomFields;
    newCustomFields.push(field);

    this.setState({
      ...this.state,
      showAddFieldButton: true,
      newCustomFields: newCustomFields,
    });
  }

  _removeNewCustomField(field) {
    var newCustomFields = [
      ...this.state.newCustomFields.filter((item) => item.name !== field.name),
    ];

    this.setState({
      newCustomFields: newCustomFields,
    });
  }

  _renderAddNewCustomFieldButton() {
    var opportunityFields = this.state.opportunityFields;

    if (this.state.newCustomFields) {
      var selectedFields = this.state.newCustomFields.map((item) => item.name);

      opportunityFields = [
        ...opportunityFields.filter(
          (item) => selectedFields.indexOf(item.name) === -1
        ),
      ];
    }

    if (this.state.customFields) {
      var selectedFields = this.state.customFields.map(
        (item) => item.integrationFieldId
      );

      opportunityFields = [
        ...opportunityFields.filter(
          (item) => selectedFields.indexOf(item.name) === -1
        ),
      ];
    }

    if (
      this.state.newCustomFields.length > 0 &&
      opportunityFields.length === 0
    ) {
      return <span></span>;
    }

    if (this.state.showAddFieldButton) {
      return (
        <div className={styles.addFields}>
          {this.state.editMode &&
            <div
              className={styles.button}
              onClick={() => {
                this._handleAddFieldButton()
              }}
            >
              <i
                className={cx("paperflite-add", styles.add)}
                aria-hidden="true"
              />
              { this.localizedIntegrations.add_fields }
            </div>}
        </div>
      );
    }

    return (
      <div className={styles.opportunityField}>
        <OpportunityFieldDropdown
          fields={[...opportunityFields]}
          addNewCustomField={this._addNewCustomField}
          onRemove={this._handleAddFieldButton}
        />
      </div>
    );
  }

  showOverrideConfig() {
    if (!this.state.id && this.state.primaryCreatedBy) {
      return this.state.primaryCreatedBy.id !== this.props.user.id
    }
    if (_.get(this.props.integration, "state.code") === "auth_error") {
      return true;
    }

    return false;
  }

  userOverriding() {
    if (this.props.authenticating && this.props.isSecondaryExpired) {
      return true;
    }
    return false;
  }


  handleRemoveClick() {
    this.props.deactivateSalesforceIntegration("salesforce_v2").then(() => {
      this.props.fetchSalesforceIntegration();
      this.setState({
        id: null,
        showSecondaryConfigRemoval: false,
        showSecondaryInstance: false,
        collapsePrimary: false
      })
    })
  }
  render() {
    return (
      <div className={styles.content}>
        {!this.props.loading && this.renderAdvancedSettings()}

        {(this.props.loading || this.userOverriding()) && this._renderLoading()}

        {!this.props.authenticating && !this.props.loading && !this.state.id && !this.state.showSecondaryInstance && <div>
          {!this.props.isSecondaryExpired && <p className={cx(styles.override)} onClick={() => {
            if (!this.props.isSecondaryExpired) {
              this.setState({
                showSecondaryInstance: true,
                isSecondaryInstanceEdit: true,
                expand:false
              })
            }
          }}>{this.localizedIntegrations.override_configuration}</p>}
          {this.props.isSecondaryExpired && <Row>
<Col md={8}>
            <h4 className={styles.overrideErrorHeader}>{this.localizedIntegrations.override_configuration} <i className= {cx("fa-solid fa-circle-exclamation", styles.headerIcon)}></i></h4>
              {this.props.isSecondaryExpired && this.state.isPrimaryExpired && <Alert className={styles.alertMessage} variant="warning">
                {localizedStrings.formatString(this.localizedSalesforce.error_messages.session_expired_secondary,
                  <span className={styles.cursor} onClick={this.handleSalesforceAuthenticate}>{this.localizedSalesforce.error_messages.click_here}</span>
                )}
              </Alert>}
              {this.props.isSecondaryExpired && !this.state.isPrimaryExpired && <Alert className={styles.alertMessage} variant="warning">
                {localizedStrings.formatString(this.localizedSalesforce.error_messages.session_expired, this.state.primaryEmail,
                  <span className={styles.cursor} onClick={this.handleSalesforceAuthenticate}>{this.localizedSalesforce.error_messages.click_here}</span>
                )}
              </Alert>}
            </Col>
          </Row>}
        </div>}
        {this.state.id &&
          <Row className={cx(styles.overrideSettings, styles.row)}>
            <Col md={8} className={styles.noPadding}>
              <div>
                <div align="middle"><span className={cx('paperflite-', styles.indicator, styles.active)}></span></div>
                <div>
                  <h4 className={styles.overrideHeader}>{this.localizedIntegrations.override_configuration}</h4>
                </div>
                {<span align="middle"> <span className={styles.remove} onClick={() => this.setState({ showSecondaryConfigRemoval: true })}>{this.localizedCommons.actions.remove}</span></span>}
              </div>
            </Col>
            <Col md={12}>
              {!this.props.loading && this._renderUserConfiguration()}
            </Col>
          </Row>
        }
        {this.state.showSecondaryInstance && !this.props.loading && !this.userOverriding() &&
          <Row className={cx(styles.overrideSettings, styles.row)}>
            <Col md={8} className={styles.noPadding}>
              <div>
                <div align="middle"><span className={cx('paperflite', styles.indicator, styles.active)}></span></div>
                <div>
                  <h4 className={styles.overrideHeader}>{this.localizedIntegrations.override_configuration}</h4>
                </div>
                 {this.state.isSecondaryInstanceEdit && _.get(this.props, "primaryInstanceOverride.configuration.instance") && <div align="middle"> <span className={styles.remove} onClick={() => this.setState({ showSecondaryConfigRemoval: true })}>{this.localizedCommons.actions.remove}</span></div>}
                <div className={styles.secondaryConfigEdit} onClick={this.handleSecondaryInstanceEdit.bind(this)}>
                  {!this.state.isSecondaryInstanceEdit && <span className={styles.editContainer}> <i className="paperflite-edit" /> {this.localizedCommons.actions.edit} </span>}
                </div>
              </div>
            </Col>
            <Col md={12}>
              {this._renderSecondaryInstance()}
            </Col>
          </Row>
        }

        <SlidePaneView width={"30vw"} show={this.state.changePrimaryConfig || this.state.showSecondaryOverrideSlider || this.state.showSecondaryConfigRemoval}>
          {this.state.changePrimaryConfig && this.changePrimaryConfigConfirmSlider()}
          {this.state.showSecondaryOverrideSlider && this.secondaryOverrideSlider()}
          {this.state.showSecondaryConfigRemoval && this.removeSecondaryConfigSlider()}
        </SlidePaneView>
      </div>
    );
  }

  renderAuthErrorMessage() {

    let integration = this.props.integration;

    if (_.get(integration, "primaryIntegration.id") != null) {
      integration = integration.primaryIntegration;
    }

    return (
      integration &&
      _.get(integration, "state.code") === "auth_error" && (
        <span className={styles.authMessage}>
          {`${this.localizedIntegrations.integration_expired} ${this.props.integration.type}.`}
        </span>
      )
    );
  }

  handleEditClick() {
    this.setState(prevState => {
      return {
        editMode: !prevState.editMode,
        sharedFieldsEdit: !prevState.sharedFieldsEdit
      }
    })
  }

  renderAdvancedSettings() {
    return (
      <>
   <Row className={cx(styles.settings, styles.row)} onClick={()=>{
        if(!this.state.showSecondaryInstance){
          return
        }
        this.setState({
          expand: !this.state.expand
        })
      }}>
        <Col md={8} className={cx(styles.noPadding,styles.headerColumn)}>
            {
              this.state.showSecondaryInstance &&  <span className={cx({
              ["paperflite-plus"]: !this.state.expand,
              ["paperflite-minus"]: this.state.expand 
            })} />
            } 
           
            <div>
              <h4 className={cx(styles.settingsHeader,{
                [styles.collapsible]: !this.state.isPrimaryExpired && (this.state.id || this.state.showSecondaryInstance || this.state.collapsePrimary)
              })}>{ this.localizedIntegrations.admin_configuration }  <span className={styles.error}> {this.state.isPrimaryExpired && <i className="fa-solid fa-circle-exclamation" />} </span> </h4>
              {this.state.isPrimaryExpired && <Alert className={cx(styles.alertMessage, styles.adminError)} variant="warning">
                {this.canEdit() ? this.localizedSalesforce.error_messages.primary_expired.sub_text : this.localizedSalesforce.error_messages.expired}
              </Alert>}
            </div>
        </Col>
      </Row>
      {
      !this.state.isPrimaryExpired &&  <Collapse in={!this.state.isPrimaryExpired && _.get(this.state,"expand")} className={styles.advanceSettings}>
      {!this.props.loading &&  this._renderAdminConfiguration()}
      </Collapse>
      }
    
      </>

    )
  }

  handleSecondaryConfigEdit() {
    this.setState(prevState => {
      return {
        isSecondaryConfigEdit: !prevState.isSecondaryConfigEdit
      }
    })
  }

  _renderUserConfiguration() {
    return (
      <Row className={styles.row}>
        <Col md={8} className={styles.formContainer}>
          <div className={styles.form}>
            <p className={styles.errorMessage}>{this.state.errors && this.state.errors.apikey}</p>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.disableEmail}>
                <div className={styles.start}>
                  <span>{ this.localizedCommons.email }</span>
                </div>
                <FormControl
                  type='text'
                  placeholder=""
                  value={this.state.email}
                  disabled
                />
              </InputGroup>
            </FormGroup>
            <Form.Text className={styles.helpText}>{ this.localizedSalesforce.active }</Form.Text>

            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <h5>{ this.localizedIntegrations.sync_events }</h5>
              </InputGroup>
              <div className={styles.secondaryConfigEdit} onClick={this.handleSecondaryConfigEdit.bind(this)}>
                {!this.state.isSecondaryConfigEdit && <span> <i className="paperflite-edit" /> { this.localizedCommons.actions.edit } </span>}
              </div>

            </FormGroup>
            <Form.Text className={styles.helpText}>{ this.localizedSalesforce.config }</Form.Text>

            <FormGroup className={cx(styles.formGroup, styles.events)}>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.sync_deals }</label>

                <span className={cx(styles.action, styles.on)}>{ this.localizedIntgerationActions.on }</span>

              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.create_lead }</label>
                {this.state.isSecondaryConfigEdit &&
                  <SwitchButton
                  id="syncLeadCreatedEvent"
                  className={styles.switch}
                  checked={this.state.syncLeadCreatedEvent}
                  handleCheck={() => {
                  this._toggleSwitchChange("syncLeadCreatedEvent")
                  } 
                  }
                  />}
                {!this.state.isSecondaryConfigEdit &&
                  <span className={cx(styles.action, { [styles.on]: this.state.syncLeadCreatedEvent })}>{this.state.syncLeadCreatedEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off }</span>
                }
              </div>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_asset }</label>
                {this.state.isSecondaryConfigEdit && <SwitchButton 
                  id="syncReadAssetEvent"
                  checked={this.state.syncReadAssetEvent}
                  handleCheck={() => this._toggleSwitchChange("syncReadAssetEvent")}  />}

                {!this.state.isSecondaryConfigEdit &&
                  <span className={cx(styles.action, { [styles.on]: this.state.syncReadAssetEvent })}>{this.state.syncReadAssetEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off }</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_collection }</label>
                {this.state.isSecondaryConfigEdit && <SwitchButton 
                  id="syncReadConversationEvent"
                  checked={this.state.syncReadConversationEvent}
                  handleCheck={() => this._toggleSwitchChange("syncReadConversationEvent")}  />}
                {!this.state.isSecondaryConfigEdit &&
                  <span className={cx(styles.action, { [styles.on]: this.state.syncReadConversationEvent })}>{this.state.syncReadConversationEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off }</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.reshare_collection }</label>
                {this.state.isSecondaryConfigEdit && <SwitchButton 
                  id="syncReshareConversationEvent"
                  checked={this.state.syncReshareConversationEvent}
                  handleCheck={()=>this._toggleSwitchChange("syncReshareConversationEvent")}  />}
                {!this.state.isSecondaryConfigEdit &&
                  <span className={cx(styles.action, { [styles.on]: this.state.syncReshareConversationEvent })}>{this.state.syncReshareConversationEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off }</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.download_asset }</label>
                {this.state.isSecondaryConfigEdit &&
                  <SwitchButton 
                    id="syncAssetDownloadEvent"
                    checked={this.state.syncAssetDownloadEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncAssetDownloadEvent")} />}

                {!this.state.isSecondaryConfigEdit &&
                  <span className={cx(styles.action, { [styles.on]: this.state.syncAssetDownloadEvent })}>{this.state.syncAssetDownloadEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off }</span>
                }
              </div>
            </FormGroup>
            {this.state.isSecondaryConfigEdit &&
              <div className={styles.buttonTray}>
                <SendButton
                  className={cx(styles.save)}
                  icon="paperflite-circle"
                  title={this.props.updating ? `${this.localizedCommons.actions.saving}...` : this.localizedCommons.actions.save}
                  primary
                  disabled={this.props.updating}
                  onClick={() => this._handleSaveChangesClicked('user')}
                >
                </SendButton>
                <SendButton
                  title={this.localizedCommons.actions.cancel}
                  disabled={this.props.updating}
                  className={cx(styles.cancel)}
                  onClick={() => {
                    this._handleResetClicked();
                    this.setState({ isSecondaryConfigEdit: false })
                  }}
                >
                </SendButton>
              </div>
            }
          </div>
        </Col>
      </Row>
    );
  }

  secondaryOverrideSlider() {
    return (
      <div className={styles.sliderContainer}>
        <div >
          <div className={styles.silderContent}>
            <p className={styles.title}>{ this.localizedSalesforce.sliders.override.title }</p>
            <p className={styles.description}>{ this.localizedSalesforce.sliders.override.sub_text }</p>
          </div>
          <div className={styles.sliderBody}>
          </div>
          <div className={styles.silderButtonContainer}>
            <ButtonContainer.Tray className={cx(styles.updateActions)}>
              <ButtonContainer
                title={this.props.authenticating ? this.localizedCommons.actions.proceeding : this.localizedCommons.actions.proceed}
                className={styles.updateAction}
                primary
                disabled={this.props.authenticating}
                onClick={() => {
                  this.handleSalesforceAuthenticate();
                }}
              />

              <ButtonContainer
                title={ this.localizedCommons.actions.cancel }
                className={cx(styles.updateAction, styles.cancel)}
                onClick={() => this.setState({ showSecondaryOverrideSlider: false })} />

            </ButtonContainer.Tray>
          </div>
        </div>
      </div>
    )
  }

  changePrimaryConfigConfirmSlider() {
    return (
      <div className={styles.sliderContainer}>
        <div>
          <div className={styles.silderContent}>
            {console.log('sdfn',this.localizedSalesforce)}
            <p className={styles.title}>{ this.localizedSalesforce.sliders.change_admin_config.title }</p>
            <p className={styles.description}>{ this.localizedSalesforce.sliders.change_admin_config.sub_text }</p>
            <p className={styles.note}>{ this.localizedSalesforce.sliders.change_admin_config.note }</p>

          </div>
          <div className={styles.sliderBody}>

          </div>
          <div className={styles.silderButtonContainer}>
            <ButtonContainer.Tray className={cx(styles.updateActions)}>
              <ButtonContainer
                title={this.props.updatingPrimaryConfig ? this.localizedCommons.actions.proceeding : this.localizedCommons.actions.proceed}
                className={styles.updateAction}
                primary
                disabled={this.props.updatingPrimaryConfig}
                onClick={this.handleSalesforceAuthenticate}
              />

              <ButtonContainer
                title={this.localizedCommons.actions.cancel}
                className={cx(styles.updateAction, styles.cancel)}
                onClick={() => this.setState({ changePrimaryConfig: false })} />

            </ButtonContainer.Tray>
          </div>
        </div>
      </div>
    )
  }

  removeSecondaryConfigSlider() {
    return (
      <div className={styles.sliderContainer}>
        <div>
          <div className={styles.silderContent}>
            <p className={styles.title}>{ this.localizedSalesforce.sliders.remove_secondary.title }</p>
            <p className={styles.description}>{ this.localizedSalesforce.sliders.remove_secondary.sub_text }</p>

          </div>
          <div className={styles.sliderBody}>

          </div>
          <div className={styles.silderButtonContainer}>
            <ButtonContainer.Tray className={cx(styles.updateActions)}>
              <ButtonContainer
                title={this.props.deleting ? this.localizedCommons.actions.proceeding : this.localizedCommons.actions.proceed}
                className={styles.updateAction}
                primary
                disabled={this.props.deleting}
                onClick={this.handleRemoveClick}
              />

              <ButtonContainer
                title={this.localizedCommons.actions.cancel}
                className={cx(styles.updateAction, styles.cancel)}
                onClick={() => this.setState({ showSecondaryConfigRemoval: false })} />

            </ButtonContainer.Tray>
          </div>
        </div>
      </div>
    )
  }

  handleSalesforceAuthenticate() {
    // Calculate Position

    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

    var w = 0.8 * width;
    var h = 0.8 * height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;

    const url = buildUrl(apiUrl, {
      path: `/api/2.0/integrations/salesforce/authorize`
    })

    var newWindow = window.open(url, `Authorize salesfoce Account`, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (newWindow.focus) {
      newWindow.focus();
    }

    //Attaching message event listner
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, this.handleAuthenticateEvent, false);
    return false;
  }

  handleAuthenticateEvent(e) {

    //Removing message event listner
    var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
    var deEventer = window[detachEventMethod];
    var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type == 'SALESFORCE_AUTHORIZATION_SUCCESS') {
      var code = e.data.payload.code;
      var state = e.data.payload.state;
      var error = e.data.payload.error;
      var id = this.state.primaryId;
      if (!error) {
        if (this.state.changePrimaryConfig || this.state.isPrimaryExpired) {
          this.props.changePrimaryConfiguration(id, code).then(() => {
            this.props.fetchSalesforceIntegration();
            this.setState({ changePrimaryConfig: false, isPrimaryExpired: false })
            this.renderToast()
          })
        }
        else if (this.state.showSecondaryOverrideSlider || this.props.isSecondaryExpired) {
          this.props.authenticateSecondaryAccount(code, this.state.primaryId).then(() => {
            this.setState({
              showSecondaryOverrideSlider: false,
              showSecondaryInstance: false,
              collapsePrimary: true,
              expand: false
            })
            this.renderToast()

          })
        }
      }

      deEventer(messageEvent, this.handleAuthenticateEvent, false);
    }
  }

  renderToast() {
    return toast(
      <Toast.Sucess
        message={this.localizedIntegrations.toast.salesforce}
      />,
      {
        autoClose: 3000,
      }
    )
  }

  handleSecondaryInstanceEdit() {
    this.setState(prevState => {
      return {
        isSecondaryInstanceEdit: !prevState.isSecondaryInstanceEdit
      }
    })
  }

  handleSecondaryInstanceSave() {
    const request = {
      ...this.state.secondaryInstanceEvents,
      integrationId: this.state.primaryId
    }
    this.props.updatePrimaryEventsOverride(request).then(() => {
      if (this.state.isSecondaryInstanceEdit) {
        toast(
          <Toast.Sucess
            message={this.localizedIntegrations.toast.salesforce}
          />,
          {
            autoClose: 3000,
          }
        )
      }

      this.setState({
        isSecondaryInstanceEdit: false
      })
    })
  }

  handleSecondaryInstanceReset() {

    this.setState({
      secondaryInstanceEvents: {
        syncAssetDownloadEvent: _.get(this.props, "primaryInstanceOverride.configuration.syncAssetDownloadEvent", true),
        syncDeals: _.get(this.props, "primaryInstanceOverride.configuration.syncDeals", true),
        syncLeadCreatedEvent: _.get(this.props, "primaryInstanceOverride.configuration.syncLeadCreatedEvent", true),
        syncReadAssetEvent: _.get(this.props, "primaryInstanceOverride.configuration.syncReadAssetEvent", true),
        syncReadConversationEvent: _.get(this.props, "primaryInstanceOverride.configuration.syncReadConversationEvent", true),
        syncReshareConversationEvent: _.get(this.props, "primaryInstanceOverride.configuration.syncReshareConversationEvent", true),
      }
    });
  }

  _renderSecondaryInstance() {
    return (
      <Row className={cx(styles.row, styles.secondaryInstance)}>
        <Col md={8} className={styles.formContainer}>
          <div className={styles.form}>
            <FormGroup className={cx(styles.formGroup)}>
            </FormGroup>
            <Form.Text className={styles.subText}>
              {localizedStrings.formatString(this.localizedSalesforce.secondary_active,
                <span className={styles.primaryEmail}>{this.state.primaryEmail}</span>
              )}
              <br /><span onClick={() => this.setState({ showSecondaryOverrideSlider: true })}>{this.localizedSalesforce.error_messages.click_here} </span>.
            </Form.Text>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <h5>{ this.localizedIntegrations.sync_events }</h5>
              </InputGroup>
            </FormGroup>
            <Form.Text>
              { this.localizedSalesforce.config }
            </Form.Text>

            <FormGroup className={cx(styles.formGroup, styles.events)}>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.sync_deals }</label>

                <span className={cx(styles.action, styles.on)}>{ this.localizedIntgerationActions.on }</span>


              </div>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.create_lead }</label>

                {this.state.isSecondaryInstanceEdit &&
                  <SwitchButton 
                    id="syncLeadCreatedEvent"
                    checked={this.state.secondaryInstanceEvents.syncLeadCreatedEvent}
                    handleCheck={() => {
                      this.handleSecondaryInstanceEventsChange("syncLeadCreatedEvent")
                    }} />
                }
                {!this.state.isSecondaryInstanceEdit &&
                  <span className={cx(styles.action, {
                    [styles.on]: this.state.secondaryInstanceEvents.syncLeadCreatedEvent
                  })}>{this.state.secondaryInstanceEvents.syncLeadCreatedEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                }
              </div>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_asset }</label>

                {this.state.isSecondaryInstanceEdit &&
                  <SwitchButton 
                    id="syncReadAssetEvent"
                    checked={this.state.secondaryInstanceEvents.syncReadAssetEvent}
                    handleCheck={() => this.handleSecondaryInstanceEventsChange("syncReadAssetEvent")} />
                }

                {!this.state.isSecondaryInstanceEdit &&
                  <span className={cx(styles.action, { [styles.on]: this.state.secondaryInstanceEvents.syncReadAssetEvent })}>{this.state.secondaryInstanceEvents.syncReadAssetEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off }</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_collection }</label>

                {this.state.isSecondaryInstanceEdit &&
                  <SwitchButton 
                    id="syncReadConversationEvent"
                    checked={this.state.secondaryInstanceEvents.syncReadConversationEvent}
                    handleCheck={()=>this.handleSecondaryInstanceEventsChange("syncReadConversationEvent")} />
                }
                {!this.state.isSecondaryInstanceEdit &&
                  <span className={cx(styles.action, { [styles.on]: this.state.secondaryInstanceEvents.syncReadConversationEvent })}>{this.state.secondaryInstanceEvents.syncReadConversationEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.reshare_collection }</label>

                {this.state.isSecondaryInstanceEdit &&
                  <SwitchButton 
                    id="syncReshareConversationEvent"
                    checked={this.state.secondaryInstanceEvents.syncReshareConversationEvent}
                    handleCheck={()=>this.handleSecondaryInstanceEventsChange("syncReshareConversationEvent")} />
                }
                {!this.state.isSecondaryInstanceEdit &&
                  <span className={cx(styles.action, { [styles.on]: this.state.secondaryInstanceEvents.syncReshareConversationEvent })}>{this.state.secondaryInstanceEvents.syncReshareConversationEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                }
              </div>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.download_asset }</label>

                {this.state.isSecondaryInstanceEdit &&
                  <SwitchButton 
                    id="syncAssetDownloadEvent"
                    checked={this.state.secondaryInstanceEvents.syncAssetDownloadEvent}
                    handleCheck={()=>this.handleSecondaryInstanceEventsChange("syncAssetDownloadEvent")} />
                }
                {!this.state.isSecondaryInstanceEdit &&
                  <span className={cx(styles.action, { [styles.on]: this.state.secondaryInstanceEvents.syncAssetDownloadEvent })}>{this.state.secondaryInstanceEvents.syncAssetDownloadEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                }
              </div>
            </FormGroup>
            {this.state.isSecondaryInstanceEdit && <div className={styles.buttonTray}>
              <SendButton
                className={cx(styles.save)}
                icon="paperflite-circle-right"
                title={this.props.updatingPrimaryOverrideEvents ? `${this.localizedCommons.actions.saving}...` : this.localizedCommons.actions.save}
                primary
                disabled={this.props.updatingPrimaryOverrideEvents}
                onClick={this.handleSecondaryInstanceSave}
              ></SendButton>
              <SendButton
                title={this.localizedCommons.actions.cancel}
                disabled={this.props.updating}
                className={cx(styles.cancel)}
                onClick={() => {
                  this.handleSecondaryInstanceReset()
                  this.setState({ isSecondaryInstanceEdit: false })
                }}
              ></SendButton>
            </div>}

          </div>
        </Col>
      </Row>
    )
  }

  _renderAdminConfiguration() {
    return (
      <Row className={styles.row}>
        <Col md={8} >
          <div className={styles.edit} onClick={this.handleEditClick.bind(this)}>
            {!this.state.editMode && !this.state.isPrimaryExpired && this.canEdit() && <span> <i className="paperflite-edit" />  { this.localizedCommons.actions.edit } </span>}
          </div>
          <div className={styles.form}>
            <p className={styles.errorMessage}>
              {this.state.errors && this.state.errors.apikey}
            </p>

            <FormGroup className={cx(styles.formGroup)}>

              <InputGroup className={styles.disableEmail}>
                <div className={styles.start}>
                  <span>{ this.localizedIntegrations.instance_name }</span>
                </div>
                <FormControl
                  type="text"
                  placeholder=""
                  value={this.state.primaryInstance}
                  disabled
                />
              </InputGroup>
            </FormGroup>
            <Form.Text>
              { this.localizedSalesforce.active_instance }
            </Form.Text>

            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.disableEmail}>
                <div className={styles.start}>
                  <span>{ this.localizedCommons.email }</span>
                </div>
                <FormControl
                  type="text"
                  placeholder=""
                  value={this.state.primaryEmail}
                  disabled
                />
              </InputGroup>
              {this.state.editMode && <span className={styles.changeButton}
                onClick={() =>
                  this.setState({
                    changePrimaryConfig: true
                  })}>{ this.localizedCommons.actions.change }</span>}
            </FormGroup>
            <Form.Text>
              { this.localizedSalesforce.active }
            </Form.Text>

            <FormGroup className={cx(styles.formGroup, styles.sharedFields)}>
              <InputGroup>
                <div className={styles.text}>
                  <h5> { this.localizedIntegrations.shared_fields } </h5>
                </div>

                <ButtonGroup className={cx(styles.btnGroup, "pull-right")}>
                  {!_.isEmpty(this.props.customFields) && this.canEdit() && (
                    <div>
                      <Button
                        className={styles.btn}
                        onClick={() => this._handleSyncSharedFields()}
                      >
                        <i
                          className={cx(
                            "fa fa-refresh",
                            this.state.sharedFieldsSync ? "fa-spin" : ""
                          )}
                        />{" "}
                        {this.state.sharedFieldsSync ? this.localizedCommons.actions.syncing : this.localizedCommons.actions.sync }
                      </Button>
                    </div>
                  )}
                </ButtonGroup>
              </InputGroup>
            </FormGroup>
            <Form.Text>
              { this.localizedSalesforce.custom_fields }
            </Form.Text>

            {this.state.editMode
              ? this._renderCustomFieldsInEditMode()
              : this._renderCustomFieldsInTags()}

            {this.props.loadingFields && _.isEmpty(this.props.opportunityFields) &&
              <div className={styles.loadingFields}>
                <span
                  className={cx("fa-solid fa-arrows-rotate", styles.loadingIcon)}
                />
                <span className={styles.loadingContent}>{ this.localizedIntegrations.loading_shared_fields }...</span>
              </div>
            }

            <div>
              {this._renderNewCustomFields()}

              {!_.isEmpty(this.props.opportunityFields) &&
              this._renderAddNewCustomFieldButton()
              }
            </div>


            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <h5>{ this.localizedIntegrations.sync_events }</h5>
              </InputGroup>
            </FormGroup>
            <Form.Text>
            { this.localizedSalesforce.config }
            </Form.Text>

            <FormGroup className={cx(styles.formGroup, styles.events)}>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.sync_deals }</label>

                <span className={cx(styles.action, styles.on)}> { this.localizedIntgerationActions.on } </span>


              </div>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.create_lead }</label>

                {this.state.editMode &&
                  <SwitchButton id="primarySyncLeadCreatedEvent"
                    checked={this.state.primarySyncLeadCreatedEvent}
                    handleCheck={() => {
                      this._toggleSwitchChange("primarySyncLeadCreatedEvent")
                    }} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.primarySyncLeadCreatedEvent })}>{this.state.primarySyncLeadCreatedEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off }</span>
                }
              </div>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_asset }</label>

                {this.state.editMode &&
                  <SwitchButton id="primarySyncReadAssetEvent"
                    checked={this.state.primarySyncReadAssetEvent}
                    handleCheck={() => this._toggleSwitchChange("primarySyncReadAssetEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.primarySyncReadAssetEvent })}>{this.state.primarySyncReadAssetEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_collection }</label>

                {this.state.editMode &&
                  <SwitchButton id="primarySyncReadConversationEvent"
                    checked={this.state.primarySyncReadConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("primarySyncReadConversationEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.primarySyncReadConversationEvent })}>{this.state.primarySyncReadConversationEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.reshare_collection }</label>

                {this.state.editMode &&
                  <SwitchButton id="primarySyncReshareConversationEvent"
                    checked={this.state.primarySyncReshareConversationEvent}
                    handleCheck={() => {
                      this._toggleSwitchChange("primarySyncReshareConversationEvent")
                      }} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.primarySyncReshareConversationEvent })}>{this.state.primarySyncReshareConversationEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                }
              </div>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.download_asset }</label>

                {this.state.editMode &&
                  <SwitchButton id="primarySyncAssetDownloadEvent"
                    checked={this.state.primarySyncAssetDownloadEvent}
                    handleCheck={() => this._toggleSwitchChange("primarySyncAssetDownloadEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.primarySyncAssetDownloadEvent })}>{this.state.primarySyncAssetDownloadEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                }
              </div>
            </FormGroup>
            {this.state.editMode && (
              <div className={styles.buttonTray}>
                <SendButton
                  className={cx(styles.save)}
                  icon="paperflite-circle-right"
                  title={this.props.updating ? `${this.localizedCommons.actions.saving}...` : this.localizedCommons.actions.save}
                  primary
                  disabled={this.props.updating}
                  onClick={() => this._handleSaveChangesClicked("primary")}
                ></SendButton>
                <SendButton
                  title={this.localizedCommons.actions.cancel}
                  disabled={this.props.updating}
                  className={cx(styles.cancel)}
                  onClick={() => {
                    this._handlePrimaryResetClicked();
                    this.setState({ editMode: false })
                  }}
                ></SendButton>
              </div>
            )}
          </div>
        </Col>
      </Row>
    );
  }

  canEdit() {
    if (this.props.user.admin) {
      return true;
    } else if (this.state.primaryCreatedBy) {
      return this.state.primaryCreatedBy.id === this.props.user.id;
    }
    return false;
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={ this.localizedSalesforce.empty_message.title }
        message={ this.localizedSalesforce.empty_message.sub_text }
        image={AccessDeniedIcon}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }

  _renderLoading() {
    return (
      <LoadingMessage
        className={cx(styles.loadingMessage, { [styles.userOverriding]: this.userOverriding() })}
        message={this.userOverriding() ? `${this.localizedSalesforce.loading.override}...` : `${this.localizedSalesforce.loading.config}...`}
        visible={true} />
    )
  }
}

export default SalesforceConfigurationView;
